module.exports = __webpack_public_path__ + "img/manager-green-icon.763f7095.svg";